import { createAsyncThunk } from "@reduxjs/toolkit";
import { post } from "helpers/api_helper";
import {
  GET_SUBSCRIPTION_DETAILS,
  GET_SUBSCRIPTIONS,
} from "helpers/url_helper";

export const getSubscriptions = createAsyncThunk(
  GET_SUBSCRIPTIONS,
  async (payload) => {
    const response = await post(GET_SUBSCRIPTIONS, payload);
    return response;
  }
);

export const getSubscriptionDetails = createAsyncThunk(
  GET_SUBSCRIPTION_DETAILS,
  async (payload) => {
    const response = await post(GET_SUBSCRIPTION_DETAILS, payload);
    return response;
  }
);
